export default "__VITE_ASSET__Cs4M_AL5__"